export function appendSecondBlocks(blocks, result) {
  appendPeakTable(blocks['Tabular Report'], result);
}

function appendPeakTable(lines, result) {
  //console.log(lines)
  let variables = lines[1]
    .map((line) => line.replace(/^[\r\n ]+/, ''))
    .map((line) => line.replaceAll(/ ?[\r\n]+/g, ' '))
    .map((line, index) => {
      return {
        symbol: String.fromCodePoint(index + 65),
        data: [],
        label: line.replace(/ ?\(.*/, ''),
        units: line.replace(/.*\((.*)\).*/, '$1'),
      };
    });

  for (let i = 2; i < lines.length; i++) {
    for (let j = 0; j < lines[i].length; j++) {
      variables[j].data.push(Number(lines[i][j]));
    }
  }

  const variablesObject = {};
  for (const variable of variables) {
    variablesObject[variable.symbol] = {
      data: variable.data,
      units: variable.units,
      label: variable.label,
    };
  }
  result.variables = variablesObject;
}
